import DM from 'DM';

const redirectFrame = function (fastRedirectTrackUrl) {
    const iframe = document.createElement('iframe');

    try {
        iframe.src = fastRedirectTrackUrl;
        iframe.sandbox = 'allow-same-origin allow-scripts';
        iframe.style.height = 0;
        iframe.style.width = 0;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
    } catch (err) {
        DM.LogError(err);
    }
};

window.addEventListener('RedirectToShop', ({ detail }) => {
    redirectFrame(detail);
});
